export class LegalAgreements {
  static readonly TERMS_OF_USE = '';
  static readonly PRIVACY_POLICY = '';
}
